import { useMemo } from "react";
import { graphql } from "gatsby";
import { SeasonPassPurchase, isArray } from "@parksandresorts/core";

const SeasonPassPurchaseBlock = ({
  contentful_id,
  digitalProducts,
  physicalProducts,
  reactivateProducts,
  description,
  reactivateDescription,
  reactivateInstruction,
  selectPassTypeInstruction,
  labelsOverride,
  showLargerGroupInputField,
}) => {
  const mappedLabels = useMemo(() => {
    if (!labelsOverride || !isArray(labelsOverride.list)) {
      return {};
    }

    return labelsOverride.list.reduce((labels, item) => {
      if (item.key && item.value) {
        labels[item.key] = item.value;
      }
      return labels;
    }, {});
  }, [labelsOverride]);

  const texts = {
    description: description,
    reactivateDescription: reactivateDescription,
    reactivateInstruction: reactivateInstruction,
    selectPassTypeInstruction: selectPassTypeInstruction,
  };

  return (
    <section className="block block--no-margin" style={{ paddingBottom: "2rem" }} data-contentful-id={contentful_id}>
      <SeasonPassPurchase
        digitalProducts={digitalProducts}
        physicalProducts={physicalProducts}
        reactivateProducts={reactivateProducts}
        texts={texts}
        labelsOverride={mappedLabels}
        showLargerGroupInputField={showLargerGroupInputField}
      />
    </section>
  );
};

export default SeasonPassPurchaseBlock;

export const fragmentSeasonPassPurchaseBlock = graphql`
  fragment SeasonPassPurchaseBlock on ContentfulSeasonPassPurchaseBlock {
    contentful_id
    id
    digitalProducts {
      ...ProductBlock
    }
    physicalProducts {
      ...ProductBlock
    }
    reactivateProducts {
      ...ProductBlock
    }
    description {
      raw
      references {
        __typename
        ...Link
        ...ContentPageLink
      }
    }
    reactivateDescription {
      raw
    }
    reactivateInstruction {
      raw
    }
    selectPassTypeInstruction {
      raw
    }
    labelsOverride {
      list {
        key
        value
      }
    }
    showLargerGroupInputField
  }
`;
